import React, { useCallback } from 'react'
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import moment from 'moment-timezone';
import './_SueItemUpdate.css';

interface GeneralOtherDetailsProps {
    sueData: any;
    sueInternalNumber: string;
    openingDate: Date | null;
    closingDate: Date | null;
    paymentDate: Date | null;
    customerCheckMaturityDate: Date | null;
    sueTypeLabel: string;
    sueActivityStatusLabel: string;
    sueStatusLabel: string;
    sueHandlerName: string;
    insuranceCompanyLabel: string;
    formErrors: any;
    onParameterChange: (e: any, field: string, isRequired: boolean) => void;
    onParameterPaymentChange: (e: any, field: string) => void;
    onDateChange: (field: string, date: Date) => void;
    onSueTypeChange: (e: any) => void;
    onSueActivityStatusChange: (e: any) => void;
    onSueStatusChange: (e: any) => void;
    onSueHandlerChange: (e: any) => void;
    onClearSueType: () => void;
    onClearSueActivityStatus: () => void;
    onClearSueStatus: () => void;
    onClearSueHandler: () => void;
    onInternalNumberChange: (e: any) => void;
    onInsuranceCompanyChange: (e: any) => void;
    onSueNewCommentChange: (e: any, field: string) => void;
    onSueAddComment: () => void;
    sueCommentsList: any[];
    sueTypes: any[];
    newSueComment: any;
    config: any;
}

const GeneralOtherDetails = (props: GeneralOtherDetailsProps) => {

    const handleOpeningDateChange = useCallback((date: Date) => {
        props.onDateChange('openingDate', date);
    }, [props.onDateChange]);

    const handleClosingDateChange = useCallback((date: Date) => {
        props.onDateChange('closingDate', date);
    }, [props.onDateChange]);


    return (
        <div className='white-block white-block-fixed-height'>
            <section className=''>
                <div className='section-sue-title'>
                    פרטי תביעה
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                מס' תביעה
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.sueNumber} onChange={(e: any) => props.onParameterChange(e, 'sueNumber', true)} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className={`parameter-item ${props.formErrors.policyNumber ? 'has-errors' : ''}`}>
                        <div className="field">
                            <div className="title">
                                מס' פוליסה
                            </div>
                            <div className="value">
                                <input type="text" readOnly={true} value={props.sueData.policy && props.sueData.policy.policyNumber} onChange={(e: any) => { }} onBlur={(e: any) => { }} />
                            </div>
                            <div className='error-message'>
                                שדה חובה
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                מס תביעה משפטית
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.serialNumber} onChange={(e: any) => {props.onParameterChange(e, 'serialNumber', true)}}
                                 onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                מס' פנימי
                            </div>
                            <div className="value">
                                <input type="text" readOnly={true} value={props.sueInternalNumber} onChange={props.onInternalNumberChange} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className={`parameter-item ${props.formErrors.openingDate ? 'has-errors' : ''}`}>
                        <div className="field">
                            <div className="title">
                                תאריך פתיחה
                            </div>
                            <div className="value">
                                <CompDatePicker value={props.openingDate} onChange={(date: Date) => handleOpeningDateChange(date)} />
                            </div>
                            <div className='error-message'>
                                שדה חובה
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                תאריך סגירה
                            </div>
                            <div className="value">
                                <CompDatePicker disabled={true} value={props.closingDate} onChange={(date: Date) => handleClosingDateChange(date)} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="parameter-row">
                    <div className={`parameter-item ${props.formErrors.sueType ? 'has-errors' : ''}`}>
                        <div className={`field`}>
                            <div className="title">
                                סוג תביעה
                            </div>
                            <div className="value">
                                <input type='text'
                                    list="sue_types_list"
                                    placeholder='בחר סוג תביעה'
                                    onChange={props.onSueTypeChange}
                                    value={props.sueTypeLabel}
                                />
                                <datalist id="sue_types_list">
                                    {props.sueTypes && props.sueTypes.map((c: any, i: number) => <option key={i} value={c.label}>{c.label}</option>)}
                                </datalist>
                                <div className={`x-icon ${props.sueTypeLabel == '' ? 'hide' : ''}`} onClick={() => { props.onClearSueType() }} ></div>
                            </div>
                            <div className='error-message'>
                                שדה חובה
                            </div>
                        </div>
                    </div>
                    <div className={`parameter-item ${props.formErrors.activityStatus ? 'has-errors' : ''}`}>
                        <div className="field">
                            <div className="title">
                                מצב תביעה
                            </div>
                            <div className="value">
                                <input type='text'
                                    list="statuses_list"
                                    placeholder='בחר מצב תביעה'
                                    onChange={props.onSueActivityStatusChange}
                                    value={props.sueActivityStatusLabel}
                                />
                                <datalist id="statuses_list">
                                    {props.config.sueActivityStatuses && props.config.sueActivityStatuses.map((c: any, i: number) => <option key={i} value={c.label}>{c.label}</option>)}
                                </datalist>
                                <div className={`x-icon ${props.sueActivityStatusLabel == '' ? 'hide' : ''}`} onClick={() => { props.onClearSueActivityStatus() }}></div>
                            </div>
                            <div className='error-message'>
                                שדה חובה
                            </div>
                        </div>
                    </div>
                    <div className={`parameter-item ${props.formErrors.status ? 'has-errors' : ''}`}>
                        <div className="field">
                            <div className="title">
                                סטטוס
                            </div>
                            <div className="value">
                                <input type='text'
                                    list="sue_statuses_list"
                                    placeholder='בחר סטטוס'
                                    onChange={props.onSueStatusChange}
                                    value={props.sueStatusLabel}
                                />
                                <datalist id="sue_statuses_list">
                                    {props.config.sueStatuses && props.config.sueStatuses.map((c: any, i: number) => <option key={i} value={c.label}>{c.label}</option>)}
                                </datalist>
                                <div className={`x-icon ${props.sueStatusLabel == '' ? 'hide' : ''}`} onClick={() => { props.onClearSueStatus() }}></div>
                            </div>
                            <div className='error-message'>
                                שדה חובה
                            </div>
                        </div>
                    </div>
                    <div className={`parameter-item ${props.formErrors.sueHandler ? 'has-errors' : ''}`}>
                        <div className="field">
                            <div className="title">
                                מטפל בתביעה
                            </div>
                            <div className="value">
                                <input type='text'
                                    list="sue_handlers_list"
                                    placeholder='בחר מטפל בתביעה'
                                    onChange={props.onSueHandlerChange}
                                    value={props.sueHandlerName}
                                />
                                <datalist id="sue_handlers_list">
                                    {props.config.handlers && props.config.handlers.map((c: any, i: number) => <option key={i} value={c.label}>{c.label}</option>)}
                                </datalist>
                                <div className={`x-icon ${props.sueHandlerName == '' ? 'hide' : ''}`} onClick={() => { props.onClearSueHandler() }}></div>
                            </div>
                            <div className='error-message'>
                                שדה חובה
                            </div>
                        </div>
                    </div>
                    <div className={`parameter-item ${props.formErrors.insuranceCompany ? 'has-errors' : ''}`}>
                        <div className={`field`}>
                            <div className="title">
                                חברת ביטוח
                            </div>
                            <div className="value">
                                <input type='text'
                                    list="companies_list"
                                    readOnly={true}
                                    placeholder='בחר חברת ביטוח'
                                    onChange={(e: any) => props.onInsuranceCompanyChange(e)}
                                    value={props.insuranceCompanyLabel}
                                />
                                <datalist id="companies_list">
                                    {props.config.insuranceCompanies.map((c: any, i: number) => <option key={i} value={c.label}>{c.label}</option>)}
                                </datalist>
                                {/* <div className={`x-icon ${insuranceCompanyLabel == '' ? 'hide' : ''}`} onClick={onClearInsuranceCompany}></div> */}
                            </div>
                            <div className='error-message'>
                                שדה חובה
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                שם התובע
                            </div>
                            <div className="value">
                                <input type="text" readOnly={true} value={props.sueData.customer && props.sueData.customer.fullName} onChange={(e: any) => { }} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='with-top-border'>
                <div className='section-sue-title'>
                    פרטי תשלום
                </div>
                <div className="parameter-row">
                    <div className={`parameter-item ${props.formErrors.requestedAmountPayment ? 'has-errors' : ''}`}>
                        <div className="field">
                            <div className="title">
                                סכום שנתבע
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.requestedAmount} onChange={(e: any) => props.onParameterPaymentChange(e, 'requestedAmount')} onBlur={(e: any) => { }} />
                            </div>
                            <div className='error-message'>
                                שדה חובה
                            </div>
                        </div>
                    </div>
                    <div className={`parameter-item ${props.formErrors.approvedAmountPayment ? 'has-errors' : ''}`}>
                        <div className="field">
                            <div className="title">
                                סכום שאושר
                            </div>
                            <div className="value">
                                <input type="text" value={props.sueData.approvedAmount} onChange={(e: any) => props.onParameterPaymentChange(e, 'approvedAmount' )} onBlur={(e: any) => { }} />
                            </div>
                            <div className='error-message'>
                                שדה חובה
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                תאריך תשלום
                            </div>
                            <div className="value">
                                <CompDatePicker value={props.paymentDate} onChange={(date: Date) => props.onDateChange('paymentDate', date)} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                תאריך פירעון שק לקוח
                            </div>
                            <div className="value">
                                <CompDatePicker value={props.customerCheckMaturityDate} onChange={(date: Date) => props.onDateChange('customerCheckMaturityDate', date)} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item"></div>
                    <div className="parameter-item"></div>
                </div>
            </section>
            <section className='with-top-border flex-space-between'>
                <div style={{ flexGrow: '1' }}>
                    <div className='section-sue-title'>
                        הערות
                    </div>
                    <div>
                        <div>
                            הערה
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '10px' }}>
                            <div>
                                <input
                                    style={{ height: '24px', padding: '5px 10px', border: '1px solid #d3dee6', width: '600px' }}
                                    type="text" value={props.newSueComment.comment ? props.newSueComment.comment : ''} onChange={(e: any) => props.onSueNewCommentChange(e, 'comment')} onBlur={(e: any) => { }} />
                            </div>
                            <div>
                                <button 
                                 className='btn-save-comment' 
                                onClick={props.onSueAddComment} 
                                disabled={props.newSueComment.comment == null || props.newSueComment.comment.length == 0}
                                >הוסף הערה</button>
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: '40px' }}>
                        <div className='comment-header' >
                            <div className="item-comment" style={{ color: 'gray' }}>
                                הערה
                            </div>
                            <div className="item-owner" style={{ color: 'gray' }}>
                                תאריך
                            </div>
                            <div className="item-owner" style={{ color: 'gray' }}>
                                משתמש
                            </div>
                        </div>
                        <div className="content-table-body files-table">
                            {props.sueCommentsList && props.sueCommentsList.sort((a, b) => {
                                return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
                            }).map((comment: any, index: number) => {
                                const user = props.config && props.config.users && props.config.users.find((u: any) => u.id === comment.userId);
                                const userName = user ? user.fullName : '';
                                return (
                                    <div className="comment-body-line" key={index}>
                                        <div className="item-comment">
                                            {comment.comment}
                                        </div>
                                        <div className="item-owner">
                                            {comment.createdDate && moment(comment.createdDate).format('DD-MM-YYYY')}
                                        </div>
                                        <div className="item-owner">
                                            {userName}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default GeneralOtherDetails